import React, { useState } from 'react';
import './PatientTestimonials.css';

import avatar1 from '../assets/avatar1.png';
import avatar2 from '../assets/avatar2.png';
import avatar3 from '../assets/avatar3.png';
import avatar4 from '../assets/avatar4.png';

import video1 from '../assets/vid1.mp4';
import video2 from '../assets/vid2.mp4';
import video3 from '../assets/vid3.mp4';
import video4 from '../assets/vid4.mp4';


const testimonials = [
  {
    avatar: avatar1,
    video: video1,
    name: "Brinda Garach",
    description: "42 years, Cervical Radiculopathy",
  },
  {
    avatar: avatar2,
    video: video2,
    name: "Anjali Kavishwar",
    description: "85 years, Osteoarthritis and Varicose Vein",
  },
  {
    avatar: avatar3,
    video: video3,
    name: "Vikas Kamat",
    description: "69 years, Frozen Shoulder",
  },
  {
    avatar: avatar4,
    video: video4,
    name: "Pushpavati Babar",
    description: "60 years, B/L Knee Osteoarthritis",
  },
];

const PatientTestimonials = () => {
  const [selected, setSelected] = useState(0);

  const handleAvatarClick = (index) => {
    setSelected(index);
  };

  const current = testimonials[selected];

  return (
    <section className="testimonials-section">
      <h3 className="testimonial-heading">Hear what our patients have to say</h3>

      {/* Avatar Row */}
      <div className="avatar-row">
        {testimonials.map((item, index) => (
          <img
            key={index}
            src={item.avatar}
            alt={`Patient ${index + 1}`}
            className={`testimonial-avatar ${index === selected ? 'active-avatar' : ''}`}
            onClick={() => handleAvatarClick(index)}
          />
        ))}
      </div>

      {/* Video Display */}
      <div className="video-testimonial">
        <div className="video-container">
          <video key={current.video} controls poster={current.avatar}>
            <source src={current.video} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="video-overlay-text">
            <h4>{current.name}</h4>
            <p>{current.description}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PatientTestimonials;
